import { render } from "./ProductsApp.vue?vue&type=template&id=79bab017&scoped=true"
import script from "./ProductsApp.vue?vue&type=script&lang=js"
export * from "./ProductsApp.vue?vue&type=script&lang=js"

import "./ProductsApp.vue?vue&type=style&index=0&id=79bab017&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bab017"]])

export default __exports__